"use client";

import React from "react";
import { Button } from "../common/button";

export interface HeroWithImagesProps {
  trustedByCount?: string;
  trustedByAvatars?: Array<{
    src: string;
    alt: string;
  }>;
  title: string;
  subtitle: string;
  ctaText: string;
  onCtaClick?: () => void;
  images?: {
    left: string;
    middle: string;
    right: string;
  };
}

export function HeroWithImages({
  trustedByCount = "38,000+ Canadians",
  trustedByAvatars = [
    { src: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&q=80", alt: "User" },
    { src: "https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=100&h=100&fit=crop&q=80", alt: "User" },
    { src: "https://images.unsplash.com/photo-1598550874175-4d0ef436c909?w=100&h=100&fit=crop&q=80", alt: "User" },
    { src: "https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=100&h=100&fit=crop&q=80", alt: "User" },
    { src: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&q=80", alt: "User" }
  ],
  title,
  subtitle,
  ctaText,
  onCtaClick,
  images = {
    left: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/65154e69ae1ad53c6e8aac5a_home-v1-hero-image-right-startux-webflow-ecommerce-template.jpg",
    middle: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/65154e69ae1ad53c6e8aac58_home-v1-hero-image-middle-startux-webflow-ecommerce-template.jpg",
    right: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/65154e69ae1ad53c6e8aac59_home-v1-hero-image-left-startux-webflow-ecommerce-template.jpg"
  }
}: HeroWithImagesProps) {
  return (
    <section className="pt-16 pb-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Left content */}
          <div className="flex-1 text-center lg:text-left">
            {/* Trusted by component - moved to top */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-2 sm:gap-3 mb-6">
              <div className="flex -space-x-3">
                {trustedByAvatars.map((avatar, index) => (
                  <img 
                    key={index}
                    className="w-10 h-10 rounded-full border-2 border-white object-cover" 
                    src={avatar.src} 
                    alt={avatar.alt} 
                  />
                ))}
              </div>
              <span className="text-gray-600 text-sm sm:text-base">Trusted by {trustedByCount}</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              {title}
            </h1>
            
            <p className="text-lg md:text-xl text-gray-600 mb-8">
              {subtitle}
            </p>
            
            <Button 
              size="lg" 
              className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-4 text-lg"
              onClick={onCtaClick}
            >
              {ctaText}
            </Button>
          </div>
          
          {/* Right content - 3 images like alli.io */}
          <div className="flex-1 relative w-full max-w-md lg:max-w-none mx-auto">
            <div className="flex gap-2 md:gap-3 items-start justify-center lg:justify-end">
              <img 
                src={images.left}
                alt="Therapy session" 
                className="w-24 sm:w-28 md:w-32 h-64 sm:h-80 md:h-96 object-cover rounded-xl md:rounded-2xl"
              />
              <img 
                src={images.middle}
                alt="Happy client" 
                className="w-24 sm:w-28 md:w-32 h-64 sm:h-80 md:h-96 object-cover rounded-xl md:rounded-2xl mt-8 sm:mt-12 md:mt-16"
              />
              <img 
                src={images.right}
                alt="Therapy conversation" 
                className="w-24 sm:w-28 md:w-32 h-64 sm:h-80 md:h-96 object-cover rounded-xl md:rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}